import {
  buildQueries,
  getDefaultNormalizer,
  queryAllByText,
} from '@testing-library/react'

const normalizer = getDefaultNormalizer({
  trim: true,
  collapseWhitespace: true,
})

export const queryAllButtonByText = (container: HTMLElement, text: string) => {
  return queryAllByText(container, (content, element) => {
    return (
      (element.getAttribute('role') === 'button' ||
        element.tagName.toLowerCase() === 'button') &&
      normalizer(element.textContent) === text
    )
  })
}

const getButtonMultipleError = (c, queryText) =>
  `Found multiple buttons with text: ${queryText}`
const getButtomMissingError = (c, queryText) =>
  `Unable to find a button with text: ${queryText}`

const [
  queryButtonByText,
  getAllButtonByText,
  getButtonByText,
  findAllButtonByText,
  findButtonByText,
] = buildQueries(
  queryAllButtonByText,
  getButtonMultipleError,
  getButtomMissingError
)

export {
  queryButtonByText,
  getAllButtonByText,
  getButtonByText,
  findAllButtonByText,
  findButtonByText,
}
